import { useCallback } from 'react';

export const useFilterHandlers = (setFilters) => {
  const handleStatusChange = useCallback((e) => {
    setFilters(prev => ({ ...prev, status: e.target.value }));
  }, [setFilters]);

  const handlePaymentChange = useCallback((e) => {
    setFilters(prev => ({ ...prev, paymentMode: e.target.value }));
  }, [setFilters]);

  const handleStartDateChange = useCallback((e) => {
    setFilters(prev => ({ ...prev, startDate: e.target.value }));
  }, [setFilters]);

  const handleEndDateChange = useCallback((e) => {
    setFilters(prev => ({ ...prev, endDate: e.target.value }));
  }, [setFilters]);

  const handleYearChange = useCallback((e) => {
    setFilters(prev => ({ ...prev, year: e.target.value }));
  }, [setFilters]);

  const handleCompareYearChange = useCallback((e) => {
    setFilters(prev => ({ ...prev, compareYear: e.target.value }));
  }, [setFilters]);

  return {
    handleStatusChange,
    handlePaymentChange,
    handleStartDateChange,
    handleEndDateChange,
    handleYearChange,
    handleCompareYearChange
  };
};
